import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container, Form, Grid } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import AcceptTOS from './AcceptTOS';
import LoginService from '../../../Services/LoginService';
import OnboardingService from '../../../Services/OnboardingService';

import {
  setSignupActive,
  setSignupCompleted,
  setSignupEmail,
} from '../../../Actions/actions_signup';
import * as qs from 'qs';

class SignupForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validating: false,
      tosAccepted: false,
      // Commented out as part of ticket to remove Google SSO
      // googleId: null,
      // facebookId: null,
      email: '',
      password: '',
      password_confirm: '',
    };
    this.emailRef = React.createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.setSignupActive();

    const parms = window.location.search;

    const email = new URLSearchParams(parms).get('email');

    if (email) {
      this.setState({
        email: email,
      });
    }

    // Commented out as part of ticket to remove Google SSO
    // LoginService.getSocialIDs()
    //   .then((data) => {
    //     /** @namespace data.google */
    //     /** @namespace data.facebook */
    //     // TODO: Should not use _mounted. https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
    //     // eslint-disable-next-line no-underscore-dangle
    //     this.setState({
    //       googleId: data.google,
    //       facebookId: data.facebook,
    //     });
    //   })
    //   .catch((e) => {
    //     console.error(e);
    //   });
  }

  handleChange = (event) => {
    const data = {};
    data[event.target.id] = event.target.value;
    this.setState(data);
  };

  handleSubmit(event) {
    const that = this;

    OnboardingService.userExists(this.state.email)
      .then((data) => {
        if (data.status === 'success') {
          return LoginService.userSignup(
            that.state.email,
            that.state.password,
            qs.parse(that.props.location.search, { ignoreQueryPrefix: true })
              .campaign_id
          ).then(() => {
            return LoginService.afterUserSignup(
              that.state.email,
              `signup-gmb`,
              that.props
            );
          });
        }
        return Promise.reject('Email already registered');
      })
      .catch((error) => {
        console.info(error);
        toast.error(`An Error occurred. ${error.error_description || ''}`);
        that.setState({ displayLoginErrors: true });
      });

    event.preventDefault();
  }

  render() {
    return (
      <div className="login-container register">
        <Grid centered>
          <Grid.Column mobile="16" tablet="10" computer="10">
            <Container className="login_column">
              <div>
                <h2 className="login_title">Sign Up</h2>
                <Form onSubmit={this.handleSubmit}>
                  <Form.Field>
                    <input
                      id="email"
                      placeholder="Email"
                      type="email"
                      className="form-control data-hj-whitelist"
                      name="email"
                      value={this.state.email || ''}
                      onChange={this.handleChange}
                      ref={this.emailRef}
                      required
                      // eslint-disable-next-line jsx-a11y/no-autofocus
                      autoFocus
                    />
                  </Form.Field>
                  <Form.Field>
                    <input
                      id="password"
                      type="password"
                      placeholder="Password"
                      className="form-control "
                      name="password"
                      value={this.state.password || ''}
                      onChange={this.handleChange}
                      required
                    />
                  </Form.Field>
                  <Form.Field>
                    <input
                      id="password_confirm"
                      type="password"
                      placeholder="Confirm Password"
                      className="form-control"
                      name="password_confirm"
                      data-private
                      value={this.state.password_confirm || ''}
                      onChange={this.handleChange}
                      required
                    />
                  </Form.Field>
                  <Form.Field>
                    <input
                      id="redirect_url"
                      type="hidden"
                      name="redirect_url"
                      data-private
                      value={''}
                    />
                  </Form.Field>
                  <div className="text-center terms">
                    {' '}
                    <AcceptTOS
                      handleChange={(e, { checked }) =>
                        this.handleChange({
                          target: { id: 'tosAccepted', value: checked },
                        })
                      }
                      accepted={this.state.tosAccepted}
                    />{' '}
                  </div>

                  <Form.Field
                    className="login_button_container"
                    style={{ marginBottom: '1em' }}
                  >
                    <Form.Button
                      color="twitter"
                      className="login_button"
                      disabled={
                        !this.state.tosAccepted || this.state.validating
                      }
                    >
                      Sign Up
                    </Form.Button>
                  </Form.Field>
                </Form>
              </div>
              <p className="login text-center">
                Already have an account?{' '}
                <a
                  onClick={() => {
                    LoginService.routeWithParams('login', this.props);
                  }}
                >
                  Log in
                </a>
              </p>
            </Container>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

SignupForm.propTypes = {
  setSignupActive: PropTypes.func,
  setSignupCompleted: PropTypes.func,
  setSignupEmail: PropTypes.func,
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {
  setSignupActive: setSignupActive,
  setSignupCompleted: setSignupCompleted,
  setSignupEmail: setSignupEmail,
})(SignupForm);
